export const getEmailService = `
query MyQuery($hotelId: String!, $id: String!, $lang: String) {
  getEmailService(input: { hotelId: $hotelId, id: $id, lang: $lang }) {
    audience {
      guests {
        blockCodes {
        logic 
        values }
        loyaltyTiers { logic values }
        roomTypes { logic values }
        rooms { logic values }
      }
      staff { emails }
    }
    bcc
    cc
    createdBy
    createdAt
    fromAddress
    fromName
    hotelId
    htmlTemplateBody
    id
    isPublished
    name
    subject
    version
    updatedBy
    updatedAt
    templateType
  }
}
`;

export const getEmailServices = `
query MyQuery($hotelId: String!, $lang: String) {
  getEmailServicesDetails(input: { hotelId: $hotelId, lang: $lang }) {
    audience {
      guests {
        blockCodes { logic values }
        loyaltyTiers { logic values }
        roomTypes { logic values }
        rooms { logic values }
      }
      staff { emails }
    }
    bcc
    cc
    createdAt
    createdBy
    fromAddress
    fromName
    hotelId
    htmlTemplateBody
    id
    isPublished
    name
    subject
    version
    updatedBy
    updatedAt
    templateType
  }
}
`;

export const getlistEmailTemplateVariables = `
query ListEmailTemplateVariables($listType: String!, $modules: [String]) {
  listEmailTemplateVariables(input: { listType: $listType, modules: $modules }) {
    keyword
    type
  }
}
`;

export const getDefaultTemplate = `
query MyQuery($templateType: String!) {
  getDefaultTemplate(input: { templateType: $templateType }) {
    id
    value
  }
}
`;

export const listSentEmailsQuery = `
  query ListSentEmails($input: ListSentEmailsInput!) {
    listSentEmails(input: $input) {
      id
      hotelId
      fromAddress
      cc
      subject
      body
      toEmails
      attachmentKeys
      sentAt
      createdAt
      createdBy
      status
      messageId
      errorMessage
      audience {
        type
        emails
        guestSegments {
          rooms
          roomTypes
          blockCodes
          loyaltyTiers
        }
      }
    }
  }
`;
